import * as MuiIcons from "@mui/icons-material";

export const projectIcons = {
  Action: {
    Close: MuiIcons.Close,
    CancelFilled: MuiIcons.Cancel,
    Remove: MuiIcons.Remove,
    Add: MuiIcons.Add,
    Edit: MuiIcons.Edit,
    Search: MuiIcons.Search,
    DownloadFile: MuiIcons.FileDownload,
    UploadFile: MuiIcons.FileUpload,
    Sort: MuiIcons.Sort,
    FilterList: MuiIcons.FilterList,
    LogOut: MuiIcons.Logout,
    PersonAdd: MuiIcons.PersonAdd,
    Resize: MuiIcons.OpenInFull,
    DragIndicator: MuiIcons.DragIndicator,
    PlayArrow: MuiIcons.PlayArrow,
    PlayCircleOutlined: MuiIcons.PlayCircleOutline,
    Print: MuiIcons.Print,
    Copy: MuiIcons.ContentCopy,
    Paste: MuiIcons.ContentPaste,
    SwapHorizontal: MuiIcons.SwapHoriz,
    BookmarkFilled: MuiIcons.Bookmark,
    BookmarkOutlined: MuiIcons.BookmarkBorder,
    Send: MuiIcons.Send,
    OpenInNew: MuiIcons.OpenInNew,
    Delete: MuiIcons.Delete,
    Refresh: MuiIcons.Refresh,
    ShareArrow: MuiIcons.IosShare,
    ShareVariant: MuiIcons.Share,
  },
  Navigation: {
    FindLocation: MuiIcons.TravelExplore,
    ArrowDropDown: MuiIcons.ArrowDropDown,
    ArrowDropUp: MuiIcons.ArrowDropUp,
    MenuHorizontal: MuiIcons.MoreHoriz,
    MenuVertical: MuiIcons.MoreVert,
    HamburgerMenu: MuiIcons.Menu,
    ExpandLess: MuiIcons.ExpandLess,
    ExpandMore: MuiIcons.ExpandMore,
    ChevronLeft: MuiIcons.ChevronLeft,
    ChevronRight: MuiIcons.ChevronRight,
    FirstPage: MuiIcons.FirstPage,
    LastPage: MuiIcons.LastPage,
    Dot: MuiIcons.FiberManualRecord,
    Home: MuiIcons.Home,
    Storefront: MuiIcons.Storefront,
    Settings: MuiIcons.Settings,
    AccountCircle: MuiIcons.AccountCircle,
    SupportAgent: MuiIcons.SupportAgent,
  },
  Status: {
    CheckCircleOutlined: MuiIcons.CheckCircleOutline,
    CheckCircleFilled: MuiIcons.CheckCircle,
    CheckFilled: MuiIcons.Check,
    WarningOutlined: MuiIcons.WarningAmber,
    WarningFilled: MuiIcons.Warning,
    ErrorOutlined: MuiIcons.ErrorOutline,
    ErrorFilled: MuiIcons.Error,
    HelpOutlined: MuiIcons.HelpOutline,
    HelpFilled: MuiIcons.Help,
    CheckVerified: MuiIcons.Verified,
    InfoOutlined: MuiIcons.InfoOutlined,
    InfoFilled: MuiIcons.Info,
    Disabled: MuiIcons.Block,
    LockFilled: MuiIcons.Lock,
    NotificationFilled: MuiIcons.Notifications,
    NotificationOutlined: MuiIcons.NotificationsNone,
  },
  General: {
    Heart: MuiIcons.Favorite,
    Receipt: MuiIcons.Receipt,
    PhotoFilled: MuiIcons.Photo,
    PhotoOutlined: MuiIcons.PhotoOutlined,
    Link: MuiIcons.Link,
    Phone: MuiIcons.Phone,
    Time: MuiIcons.AccessTime,
    DateRange: MuiIcons.DateRange,
    CreditCard: MuiIcons.CreditCard,
    StarFilled: MuiIcons.Star,
    StarHalfFilled: MuiIcons.StarHalf,
    StarOutlined: MuiIcons.StarBorder,
    DeliveryTruck: MuiIcons.LocalShipping,
    DeliveredStatus: MuiIcons.Inventory2,
    People: MuiIcons.People,
    LocationPin: MuiIcons.LocationOn,
    LocationPinCircle: MuiIcons.PinDrop,
    Folder: MuiIcons.Folder,
    Mail: MuiIcons.Mail,
    MailOpened: MuiIcons.Drafts,
    ShoppingCart: MuiIcons.ShoppingCart,
    ColorWheel: MuiIcons.ColorLens,
  },
};
